import clsx from 'clsx';
import { useEffect, useState } from 'react';
import './ServiceType.scss';
import { Service } from '@/features/services';
import DeleteIcon from '@/assets/img/Close-new.svg';
import { ServiceDetail } from '@/features/events';

export type ServiceTypesProps = {
  services?: Service[] | ServiceDetail[];
  name?: string;
  enableDelete?: boolean;
  onDeleteService?: (service: Service | ServiceDetail) => void;
  restrictService?: boolean;
  onViewChange?: (showMore: boolean, count: number) => void;
  expandedMode?: boolean;
};

export const ServiceTypes = ({
  services,
  enableDelete,
  onDeleteService,
  restrictService = false,
  onViewChange,
  expandedMode = false,
}: ServiceTypesProps) => {
  useEffect(() => {
    setShowMore(expandedMode);
  }, [expandedMode]);

  const [showMore, setShowMore] = useState<boolean>(false);

  const showOrHideServiceType = () => {
    setShowMore(!showMore);
    if (services && onViewChange) {
      onViewChange(!showMore, services?.length);
    }
  };
  const onDeleteServiceItem = (service: Service | ServiceDetail) => {
    onDeleteService && onDeleteService(service);
  };
  const filteredServices =
    restrictService && services?.length && services?.length > 3
      ? showMore
        ? services
        : services?.slice(0, 3)
      : services;
  return (
    <div className="service-type-container">
      {filteredServices?.map((service) => (
        <span className="service-type" style={{ backgroundColor: service?.color }}>
          {/* <span className="circle" style={{ backgroundColor: service?.color }} /> */}
          {service?.name}{' '}
          {enableDelete && (
            <img
              src={DeleteIcon}
              className="delete-icon"
              onClick={() => onDeleteServiceItem(service)}
            />
          )}
        </span>
      ))}
      {restrictService && services && services?.length > 3 && (
        <span className="service-type clickable" onClick={showOrHideServiceType}>
          {showMore ? 'less...' : 'more...'}
        </span>
      )}
    </div>
  );
};

ServiceTypes.displayName = 'ServiceTypes';
